export const giaVon = {
  title: 'Costing',
  titles: {
    list: 'Shipment costing list',
    edit: 'Update shipment costing',
    config: 'Update fixed costing fee',
  },
  fields: {
    maLoHang: 'Shipment code',
    tenSanPham: 'Product name',
    tenKhachHang: 'Customer',
    maContainer: 'Container code',
    thanhTienVon2: 'Cost amount 2',
    thanhTienChot: 'Final amount',
    laiChuaThue: 'Profit before tax',
    mucCanhBao: 'Warning level',
    actions: 'Actions',
    phiGiaVonCoDinh: 'Fixed costing fee',
  },
  filter: {
    all: 'All',
    searchPlaceholder: 'Search by shipment code / product name',
    fromDate: 'From date',
    toDate: 'To date',
    warningLevel: 'Warning level',
  },
  update: {
    chiPhiDauTQ: 'China source cost',
    phiShip: 'Shipping fee',
    phiKhac: 'Other fee',
    thueNKThuKhach: 'Import tax charged',
    thueVATThuKhach: 'VAT charged',
    thueKhac: 'Other tax',
    phanTramUTNK: '% import delegation',
    utnk: 'Import delegation fee',
    chiPhiKTCL: 'Quality check fee',
  },
  actions: {
    exportExcel: 'Export Excel',
    config: 'Fixed fee',
  },
  messages: {
    noData: 'No data',
  },
}
